export const ZOOM_STEP = 0.1;
export const ZOOM_MIN = 0.2;
export const ZOOM_MAX = 5;

export const HARDCODED_PROMPTS = [
	{
		title: "notes.creation.hardcoded-prompt.executive-summary",
		prompt: "notes.creation.hardcoded-prompt.executive-summary.prompt",
	},
	{
		title: "notes.creation.hardcoded-prompt.criteria-selection",
		prompt: "notes.creation.hardcoded-prompt.criteria-selection.prompt",
	},
	{
		title: "notes.creation.hardcoded-prompt.disciplines-trades",
		prompt: "notes.creation.hardcoded-prompt.disciplines-trades.prompt",
	},
	{
		title: "notes.creation.hardcoded-prompt.required-material",
		prompt: "notes.creation.hardcoded-prompt.required-material.prompt",
	},
	{
		title: "notes.creation.hardcoded-prompt.applicable-standards",
		prompt: "notes.creation.hardcoded-prompt.applicable-standards.prompt",
	},
	{
		title: "notes.creation.hardcoded-prompt.geographic-scope",
		prompt: "notes.creation.hardcoded-prompt.geographic-scope.prompt",
	},
];

export const SKIP_CONTENT_BOX_DELETE_CONFIRM_KEY = "notes.skipContentBoxDeleteConfirm";
